import { css } from 'styled-components';

export const focusRingColor = '#2e82ff';

export const focusRing = css`
  outline: solid 3px ${focusRingColor};
  outline-offset: 2px;
`;
